__turbopack_context__.v({
  "Content": "DotPagination-module-scss-module__H-hbGq__Content",
  "Item": "DotPagination-module-scss-module__H-hbGq__Item",
  "Item___active": "DotPagination-module-scss-module__H-hbGq__Item___active",
  "Item___primary": "DotPagination-module-scss-module__H-hbGq__Item___primary",
  "Wrapper": "DotPagination-module-scss-module__H-hbGq__Wrapper",
});
